import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiZod } from '@/shared/api'
import { type Project, ProjectSchema } from '../model/schema'

export const projectKeys = {
  all: ['projects'] as const,
  list: (companyId?: string) => [...projectKeys.all, 'list', companyId ?? ''] as const,
}

// Проекты справочника; без companyId — все (фильтр «проект» применим и без
// выбранной компании, контракт бэка тот же).
export function projectsQueryOptions(companyId?: string) {
  return queryOptions({
    queryKey: projectKeys.list(companyId),
    queryFn: async (): Promise<Project[]> => {
      const query = companyId ? { company: companyId } : undefined
      const body = await apiGet('/projects', apiZod.zListProjectsResponse, query)
      return (body.data ?? []).map((dto) =>
        ProjectSchema.parse({
          id: dto.id,
          companyId: dto.company_id,
          name: dto.name,
          slug: dto.slug,
        }),
      )
    },
    staleTime: 5 * 60 * 1000,
  })
}
